<template>
  <v-container class="overview-page">
    <v-row class="ma-0">
      <v-col cols="12">
        <DataTable
            :enabled-search="true"
            :headers="headers"
            :data="content"
            icon="edit"
            @clickedButton1="setQRCodeToFacility"
            sortBy="name"
        />

        <TwoButtonDialog
            ref="confirmAssignButton"
            color="grey"
            :dialog-title="$t('book/public:qrcode.table.button.title')"
            :dialog-text="$t('book/public:qrcode.table.button.text',{name : data ? data.name : ''})"
            :button1-text="$t('book/public:qrcode.table.assign')"
            :button2-text="$t('buttons:cancel')"
            @clickedButton1="setQRCodeToFacilityConfirmed()"
            @clickedButton2="$refs.confirmAssignButton.showDialog = false"
            :hide-button="true"
        />

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from "@/modules/core/components/DataTable/DataTable";
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";

export default {
  name: "QRCodeFacilityTable",
  components: {
    DataTable,
    TwoButtonDialog
  },
  data() {
    return {
      content: [],
      data: null
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:name'), value: "name"},
        {text: this.$t("common:building"), value: "buildingName"},
        {text: this.$t("common:city"), value: "buildingCity"},
        {text: this.$t("common:address"), value: "buildingStreet"},
        {text: this.$t("common:facility-number"), value: "objectNumber"},
        {text: this.$t("book/public:qrcode.table.assign"), value: "controls", sortable: false},
      ];
    },
  },
  methods: {
    setQRCodeToFacility(data) {
      this.data = data;
      this.$refs.confirmAssignButton.showDialog = true;
    },
    setQRCodeToFacilityConfirmed(){
      this.$refs.confirmAssignButton.showDialog = false;
      this.$emit("setQRCodeToFacility",this.data);
    }
  }
}
</script>
